// extracted by mini-css-extract-plugin
module.exports = {"title":"Footer_title__adPZq","footer":"Footer_footer__e2Uo_","legal":"Footer_legal__vGQkY","form":"Footer_form__KXfqX"};